export default {
  'slot-selection': 'Termin auswählen',
  'slot-selection.all': 'Alle',
  'slot-selection.empty': 'Es sind keine Termine verfügbar',
  'slot-selection.type': 'Termintyp',
  'slot-selection.time': 'Gewünschte Tageszeit',
  'slot-selection.select-date': 'Datum auswählen',
  'slot-selection.select-location': 'Bitte auwählen',
  'slot-selection.select-slot': 'Zeit auswählen',
  'slot-selection.selected-slot': 'Ausgewählter Termin',
  'slot-selection.selected-slot.clinic': 'Klinik',
  'slot-selection.selected-slot.patient': 'Patient',
  'slot-selection.go-to-confirmation': 'Weiter zur Bestätigung',
  'slot-selection.select-type': 'Bitte wählen Sie einen Termintyp aus, um fortzufahren',

  'slot-selection.selected-slot.unit': 'Einrichtung',
  'slot-selection.selected-slot.date-time': 'Datum / Uhrzeit',
  'slot-selection.selected-slot.time': 'Uhrzeit',
  'slot-selection.selected-slot.location': 'Standort',
  'slot-selection.selected-slot.contact': 'Kontakt',
  'slot-selection.selected-slot.book': 'Termin buchen',
  'slot-selection.pre-submit-form': 'Fragebogen ausfüllen',
  'slot-selection.pre-submit-form.complete': 'Fragebogen ausgefüllt',
  'slot-selection.pre-submit-form.tooltip':
    'Füllen Sie den Fragebogen aus um die Buchung oder Anfrage abzuschließen',
  'slot-selection.pre-submit-form.title': 'Fragebogen',
  'slot-selection.pre-submit-form.filled-out': 'Fragebogen ausgefüllt',
  'slot-selection.selected-slot.confirmation-title': 'Terminbuchung bestätigen',
  'slot-selection.selected-slot.confirm-appointment': 'Termin bestätigen',
  'slot-selection.selected-slot.booking-successful': 'Ihr Termin wurde erfolgreich gebucht 🎉',
  'slot-selection.selected-slot.booking-successful.automatic':
    'Ihre Terminanfrage wurde von der Klinik automatisiert bestätigt und Ihr Termin wurde gebucht.',

  'slot-selection.booking-error': 'Die Terminbuchung konnte nicht abgeschlossen werden',
  'slot-selection.booking-error.message':
    'Bitte versuchen Sie, einen anderen Zeitslot auszuwählen.',

  'appointment-request.time-frame.details': 'Bitte wählen Sie den gewünschten Zeitraum aus.',

  'slot-selection.time-range.until': 'Bis {time} Uhr',
  'slot-selection.time-range.from': 'Ab {time} Uhr',
  'slot-selection.time-range.between': '{start} – {end} Uhr',
};
